import { Card, Col, Row } from 'antd';
import './index.less';
import CommunityLogo from '../../assets/community-logo.jpg';
import TeacherLogo from '../../assets/Screen_1.jpg';
import Logo from '../../assets/White_Logo.png';

const DownloadsPage = () => {
  return (
    <div className='downloads-page'>
      {/* Header */}
      <header className='downloads-header'>
        <img src={Logo} alt='Hayati Logo' className='logo' />
        <h1>Download Hayati Apps</h1>
        <p>Get the best experience on your mobile device.</p>
      </header>

      {/* Download Cards */}
      <section className='downloads-section'>
        <Row gutter={[16, 16]} justify='center'>
          <Col>
            <Card className='download-card'>
              <img
                src={TeacherLogo}
                alt='Teacher App Splash'
                className='splash-image'
              />

              <h2>Hayati Teacher App</h2>
              <p
                style={{
                  textAlign: 'justify',
                }}
              >
                An educational platform designed for teachers to manage student
                progress, navigate Ayat by Ayat, and access professional audio
                recitations. Perfect for Quranic education and student
                assessment.
                {/* Manage student progress, navigate Ayat by Ayat, and access
            professional audio recitations. */}
              </p>

              <p className='card-description'>
                Sample login credentials: <br /> <strong>Email:</strong>{' '}
                teacher@example.com <br /> <strong>Password:</strong>{' '}
                password123
              </p>
              <div className='download-buttons'>
                <a
                  target='_blank'
                  href='https://apps.apple.com/in/app/hayati-teacher/id6737462883'
                  rel='noreferrer'
                >
                  {/* <Button type='primary' icon={<AppleOutlined />}>
                    Get on App Store
                  </Button> */}

                  <img
                    src='https://developer.apple.com/app-store/marketing/guidelines/images/badge-example-preferred.png'
                    alt='Get on App Store'
                    className='store-logo'
                  />
                </a>
                {/* <a href=''>
                  <Button type='primary' icon={<AndroidOutlined />}>
                    Get on Play Store
                  </Button>
                </a> */}
              </div>
            </Card>
          </Col>
          <Col>
            <Card className='download-card'>
              <img
                src={CommunityLogo}
                alt='Community App Splash'
                className='splash-image'
              />

              <h2>Hayati Community App</h2>
              <p
                style={{
                  textAlign: 'justify',
                }}
              >
                A community-focused platform enabling peer-to-peer learning,
                guardian engagement, and enhanced communication through
                notifications. Ideal for collaborative educational experiences.
                {/* Enhance peer-to-peer learning, guardian engagement, and
            notifications. */}
              </p>
              <p className='card-description'>
                Sample login credentials: <br /> <strong>Email:</strong>{' '}
                user@example.com <br />
                <strong>Password:</strong> password123
              </p>
              <div className='download-buttons'>
                <a
                  target='_blank'
                  href='https://apps.apple.com/in/app/hayati-community/id6738457405'
                  rel='noreferrer'
                >
                  {/* <Button type='primary' icon={<AppleOutlined />}>
                    Get on App Store
                  </Button> */}
                  <img
                    src='https://developer.apple.com/app-store/marketing/guidelines/images/badge-example-preferred.png'
                    alt='Get on App Store'
                    className='store-logo'
                  />
                </a>
                <a
                  target='_blank'
                  href='https://play.google.com/store/apps/details?id=au.hayatiapp.community'
                  rel='noreferrer'
                >
                  {/* <Button type='primary' icon={<AndroidOutlined />}>
                    Get on Play Store
                  </Button> */}
                  <img
                    src='https://w7.pngwing.com/pngs/52/715/png-transparent-google-play-logo-google-play-computer-icons-app-store-google-text-logo-sign-thumbnail.png'
                    alt='Get on App Store'
                    className='store-logo'
                    width='160px'
                    height={56}
                  />
                </a>
              </div>
            </Card>
          </Col>
        </Row>
      </section>

      {/* Footer */}
      <footer className='downloads-footer'>
        <p>© {new Date().getFullYear()} Hayati Project. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

export default DownloadsPage;
